<template>
  <span class="app-version" :class="[`app-version--${tone}`]">
    {{ versionLabel }}
  </span>
</template>

<script setup lang="ts">
import { loadMiddleVersion } from '@/common/utils/middleVersion'
import { computed, onMounted, ref } from 'vue'

interface Props {
  tone?: 'light' | 'dark'
}

const props = withDefaults(defineProps<Props>(), {
  tone: 'dark'
})

const middleVersion = ref<string | null>(null)

const clientVersion = computed(() => import.meta.env.VITE_APP_VERSION || 'dev')
const tone = computed(() => props.tone)
const versionLabel = computed(() => {
  const client = clientVersion.value
  const middle = middleVersion.value
  return middle ? `${client} (${middle})` : client
})

onMounted(async () => {
  middleVersion.value = await loadMiddleVersion()
})
</script>

<style scoped lang="scss">
.app-version {
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.app-version--light {
  color: rgba(255, 255, 255, 0.7);
}

.app-version--dark {
  color: #6b7280;
}
</style>
